// Read by every capture. A pro opt-out changes this.
// gif: Stefan asked for 60 fps; a GIF stores delays in whole hundredths, so 50 fps is the
// highest rate that plays at game speed. No file-size cap yet (see the bytes event property).
// eslint-disable-next-line import-x/prefer-default-export
export const CAPTURE_CONFIG = {
  watermark: true,
  gif: { maxLengthS: 10, width: 1280, fps: 50 },
};
